module.exports = __webpack_public_path__ + "img/c04_unitstartechrelentlesszeal_Normal_ua.9f6f1fcb.webp";